import React from "react";
import { Typography, Box, Divider } from "@mui/material";
import { SidebarAvatar } from "./SlidingSidebar";

interface EventHeaderProps {
  avatarUrl: string;
  accountName: string;
  accountAddress: string;
  selectedDate: string;
  startTime: string;
  endTime: string;
}

const EventHeader: React.FC<EventHeaderProps> = ({
  avatarUrl,
  accountName,
  accountAddress,
  selectedDate,
  startTime,
  endTime,
}) => {
  return (
    <Box
      sx={{
        mb: 0,
        p: 2,
        backgroundColor: "background.default",
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <SidebarAvatar src={avatarUrl} alt={accountName} />
        <Box
          sx={{
            flex: 1,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            {accountName}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {accountAddress}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Date:{" "}
            {new Date(selectedDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Time: {startTime} - {endTime}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ mt: 2 }} />
    </Box>
  );
};

export default EventHeader;
